// extracted by mini-css-extract-plugin
export default {"r_l":"_35b92e9729 _7b85c324a2","t":"_0054002e7d"};